export const setItem = (key, value) => localStorage.setItem(key, JSON.stringify(value))

export const getItem = (key, defaultValue = null) => {
  const value = localStorage.getItem(key)
  return value ? JSON.parse(value) : defaultValue
}

export const removeItem = (key) => localStorage.removeItem(key)
